<template>
    <div class="agentplane-support">
        <div v-if="loading" class="py-6" role="status" aria-live="polite">
            <v-progress-circular indeterminate color="primary" size="28" />
            <p class="mt-3">جارٍ تحميل محادثة الدعم…</p>
        </div>
        <div
            ref="chat"
            class="agentplane-support__frame"
            :aria-busy="loading ? 'true' : 'false'"
        />
        <p v-if="!loading && !unavailable" class="agentplane-support__hint muted--text mt-3">
            يمكنك أيضاً فتح المحادثة من الزر العائم في أسفل الشاشة في أي وقت.
        </p>
        <v-alert v-if="unavailable" type="warning" text class="mt-4">
            تعذر تحميل المحادثة. يمكنك إرسال طلب مساعدة بدلًا منها.
        </v-alert>
    </div>
</template>

<script>
import { mountAgentplaneSupport, unmountAgentplaneSupport } from '@/services/agentplane-support';

export default {
    data() {
        return { loading: true, disposed: false, timeout: null, unavailable: false };
    },
    mounted() {
        this.timeout = window.setTimeout(() => {
            if (!this.disposed && this.loading) {
                this.loading = false;
                this.unavailable = true;
                this.$emit('unavailable');
            }
        }, 15000);
        mountAgentplaneSupport(this.$refs.chat, this.$store)
            .then(() => {
                if (!this.disposed) {
                    this.loading = false;
                    this.unavailable = false;
                    this.$emit('ready');
                }
            })
            .catch(() => {
                if (!this.disposed) {
                    this.loading = false;
                    this.unavailable = true;
                    this.$emit('unavailable');
                }
            })
            .finally(() => window.clearTimeout(this.timeout));
    },
    beforeDestroy() {
        this.disposed = true;
        window.clearTimeout(this.timeout);
        unmountAgentplaneSupport(this.$refs.chat);
    },
};
</script>

<style scoped>
.agentplane-support {
    max-width: 960px;
    margin: 0 auto;
}
.agentplane-support__frame {
    height: 70vh;
    height: 70dvh;
    min-height: 520px;
}
.agentplane-support__hint {
    font-size: 0.9rem;
}
</style>
